import { HttpService } from 'src/app/system/services/HttpService';
export const DialogsCommonApi = {
    getDialogTags: (id) => {
        return HttpService.get(`/dashboard/dialogs/${id}/globalTags`);
    },
};
